/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

export const InputPlaceholderText = {
  numeric: 'Key in value',
  text: 'Key in text',
  dropdown: 'Select a value',
  dropdownOrCreate: 'Select a value or key in a new value',
} as const;
